import get from 'lodash/get'

export const wrap = (subState) => ({mobileMenu: subState})

export const isAccountMenuOpen = (state) => get(state, 'mobileMenu.isAccountMenuOpen')
export const isOpen = (state) => get(state, 'mobileMenu.isOpen', false)
export const mobileMenu = (state) => get(state, 'mobileMenu')
export const openAccordion = (state) => get(state, 'mobileMenu.openAccordion')

export const isAccordionOpen = (state, accordionId) => openAccordion(state) === accordionId
